export default "__VITE_ASSET__f4b144da__"